import React from 'react';
import CategoryList from '../../../src/components/Category/CategoryList';
const items = [
    {
        title: 'Category #1',
    },
    {
        title: 'Category with long name #2',
    },
    {
        title: 'Category #3',
        iconKind: 'ExclamationMarkTriangle',
    },
];
const Example = () => <CategoryList items={items}/>;
export default Example;
